@if (task) {
    <unclaimed-message [task]="task" (claimed)="getTask($event.id)"></unclaimed-message>
    @if (task?.purchaseRequisition) {
        <purchase-requisition-detail
            [purchaseRequisition]="task.purchaseRequisition"
            [supplierChangeAllowed]="task.supplierChangeAllowed"
            [editingWithDialog]="true"
            [supplierRequired]="needsSupplier"
            [validUntilRequired]="needsValidation"
            [task]="task"
            #purchaseRequisitionDetailComponent
        >
            <div class="row justify-content-end mb-2">
                <div class="col-auto">
                    <task-hint-display [hint]="task.hint"></task-hint-display>
                </div>
            </div>
            @if (supplierHint) {
                <div class="row justify-content-end mb-2" *removeIfUnclaimed="task">
                    <div class="col-auto">
                        <div class="alert alert-danger mb-0">
                            {{ supplierHint | translate }}
                        </div>
                    </div>
                </div>
            }
            @if (showDemandInvalidHint) {
                <!-- EPROC-11425 reopen #5b (238308): generic on purpose — the concrete reason (missing
                     field, pending currency check) is shown at its place inside the embedded demand. -->
                <div class="row justify-content-end mb-2" *removeIfUnclaimed="task">
                    <div class="col-auto">
                        <div class="alert alert-warning mb-0" data-cy="PURCHASE_REQUISITION_INVALID_HINT">
                            <em class="fas fa-circle-info pe-1"></em>
                            {{
                                'Die Freigabe ist noch nicht möglich: Die Bedarfsmeldung erfüllt noch nicht alle Voraussetzungen. Prüfen Sie die Hinweise und Pflichtfelder in der Bedarfsmeldung.'
                                    | translate
                            }}
                        </div>
                    </div>
                </div>
            }
            <div class="row justify-content-end mb-2" *removeIfUnclaimed="task">
                <!-- separate wrapping buttons: a btn-group cannot wrap and is wider than a phone screen -->
                <div class="col d-flex flex-wrap justify-content-end gap-2">
                    <button class="btn btn-secondary" (click)="sendToRework()" data-cy="REWORK">
                        <em class="fas fa-rotate-left pe-2"></em>
                        {{ 'Überarbeitung veranlassen' | translate }}
                    </button>
                    <button class="btn btn-warning" (click)="decline()" data-cy="DECLINE">
                        <em class="fas fa-ban pe-2"></em>
                        {{ 'ablehnen' | translate }}
                    </button>
                    <button
                        class="btn btn-success"
                        data-cy="APPROVE"
                        [disabled]="approvalBlocked"
                        (click)="approve()"
                    >
                        <em class="fas fa-check pe-2"></em>
                        {{ 'freigeben' | translate }}
                    </button>
                </div>
            </div>
        </purchase-requisition-detail>
    }
}
